package us.laantech.routes.pos.reports.z

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonObject

@Serializable
data class DataTableRow(
    val separator: Boolean = false,
    val fields: List<JsonObject>
)

// Dataframe not yet supported in Kotlin Multiplatform

//fun DataTable.toDataFrame(infer: Infer = Infer.None): DataFrame<*> {
//    val cols = columns.mapIndexed { i, name ->
//        createByType(name, rows.map { it[i] }, infer)
//    }
//    return dataFrameOf(cols)
//}

//fun DataFrame<*>.toDataTable(title: String?, subtitle: String? = null): DataTable {
//    return DataTable(
//        title = null,
//        subtitle = null,
//        columns = columnNames(),
//        rows = rows().map { row -> columnNames().map { col -> row[col].toString() } },
//    )
//}


@Serializable
data class DataTable(
    val title: String? = null,
    val subtitle: String? = null,
//    val dataframe: DataFrame<*>? = null,

    val columns: List<String> = listOf(),
    val rows: List<List<String>> = listOf(),

    @SerialName("footer_row")
    val footerRow: List<String>? = null,
)


@Serializable
data class ZReportDTO(
    val label: String,
    val header: JsonObject?,
    val fromDate: Long,
    val toDate: Long,
    val sections: List<DataTable> = listOf(),
    val footer: JsonObject?
)





//@Serializable
//data class ZReportSampleDTO(
//    val label: String,
//    val z_report_response_sample: zReportDTO
//)